import { createSlice } from "../helper";

const initialState = {
  focusAreas: []
};

const mentoringGoalGamePlanSlice = createSlice({
  name: "mentoringGoalGamePlan",
  initialState,
  reducers: {
    initializeFocusAreas: (state, action) => {
      const { existingFocusAreas = [] } = action.payload;
      state.focusAreas = existingFocusAreas;
    },

    setFocusAreas: (state, action) => {
      state.focusAreas = action.payload;
    }
  }
});

export const mentoringGoalGamePlanActions = mentoringGoalGamePlanSlice.actions;

export default mentoringGoalGamePlanSlice.reducer;